import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'cs/'

const initialState = {
    msg: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const restartSalesServices = createAsyncThunk('rs/rss', async (_, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'restartServices', _)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const restartServicesSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.msg = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(restartSalesServices.pending, (state) => {
                state.isLoading = true
            })
            .addCase(restartSalesServices.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.msg = action.payload
            })
            .addCase(restartSalesServices.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = restartServicesSlice.actions

export default restartServicesSlice.reducer